import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import PropTypes from 'prop-types';
import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import TextField from './fields/TextField';
import './_styles_/Search.css';
import { wafValidator } from '../hooks/validationSupport';
import useSingleValidator from '../hooks/useSingleValidator';

Search.propTypes = {
    onSearch: PropTypes.func.isRequired,
    query: PropTypes.string,
    placeholder: PropTypes.string,
    matches: PropTypes.number,
};

export const ON_SEARCH_DELAY = 500; // ms

function Search(props) {
    const {
        placeholder = null,
        onSearch,
        query = null,
        matches = null,
    } = props;
    const { t } = useTranslation();
    const { validator } = useSingleValidator(true, useMemo(() => wafValidator(t), [t]));
    const onValidated = (newValue, validationPassed) => {
        if (validationPassed) {
            onSearch(newValue);
        }
    };
    return (
        <div className="search">
            <TextField
                label={<FontAwesomeIcon icon="search" />}
                className="search-field wide"
                inputId="search-field"
                placeholder={placeholder}
                value={query}
                onValidated={onValidated}
                validator={validator}
                postfix={matches >= 0 && <span className="search-field--matches">{t('misc.match', { count: matches })}</span>}
                showCleanup
            />
        </div>
    );
}

export default Search;
